const values = new Map()
const inflight = new Map()
const diagnostics = []
const actualRequests = new Map()

function diagnosticsEnabled () {
  return process.env.NODE_ENV !== 'production'
}

function recordLookup (key, metadata, outcome) {
  if (!diagnosticsEnabled()) return
  const safe = metadata || {}
  const resource = String(key || '').split(':')[0]
  const actualCount = actualRequests.get(key) || 0
  diagnostics.push({
    operation: safe.operation || resource,
    endpoint: safe.endpoint || '',
    key: key,
    trigger: safe.trigger || 'unspecified',
    lifecycle: safe.lifecycle || 'unspecified',
    outcome: outcome,
    actual_request_count: actualCount
  })
  if (diagnostics.length > 500) diagnostics.shift()
}

export function stableLookupKey (resource, parameters) {
  const normalized = {}
  Object.keys(parameters || {}).sort().forEach(key => {
    const value = parameters[key]
    normalized[key] = Array.isArray(value) ? value.slice().map(String).sort() : value
  })
  return resource + ':' + JSON.stringify(normalized)
}

export function loadCachedLookup (key, loader, metadata) {
  if (values.has(key)) {
    recordLookup(key, metadata, 'cache_hit')
    return Promise.resolve(values.get(key))
  }
  if (inflight.has(key)) {
    recordLookup(key, metadata, 'joined_inflight')
    return inflight.get(key)
  }
  actualRequests.set(key, (actualRequests.get(key) || 0) + 1)
  recordLookup(key, metadata, 'cache_miss')
  const request = Promise.resolve().then(loader).then(result => {
    values.set(key, result)
    inflight.delete(key)
    return result
  }).catch(error => {
    inflight.delete(key)
    throw error
  })
  inflight.set(key, request)
  return request
}

export function invalidateLookupCache (prefix) {
  Array.from(values.keys()).forEach(key => {
    if (!prefix || key.indexOf(prefix) === 0) values.delete(key)
  })
  Array.from(inflight.keys()).forEach(key => {
    if (!prefix || key.indexOf(prefix) === 0) inflight.delete(key)
  })
}

export function lookupCacheState () {
  return { values: Array.from(values.keys()), inflight: Array.from(inflight.keys()) }
}

export function lookupRequestDiagnostics () {
  return diagnosticsEnabled() ? diagnostics.slice() : []
}

export function resetLookupRequestDiagnostics () {
  diagnostics.splice(0, diagnostics.length)
  actualRequests.clear()
}

export function compactRequestFingerprint (value) {
  const source = typeof value === 'string' ? value : JSON.stringify(value)
  let hash = 2166136261
  for (let index = 0; index < source.length; index += 1) {
    hash ^= source.charCodeAt(index)
    hash = Math.imul(hash, 16777619)
  }
  return (hash >>> 0).toString(36)
}
